import { render, staticRenderFns } from "./My-business.vue?vue&type=template&id=59295eea&scoped=true&"
import script from "./My-business.vue?vue&type=script&lang=js&"
export * from "./My-business.vue?vue&type=script&lang=js&"
import style0 from "./My-business.vue?vue&type=style&index=0&id=59295eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59295eea",
  null
  
)

export default component.exports